<div fxLayout="column" fxLayoutAlign="center center">
    <p class="text-center title">{{ message }}</p>
    <mat-icon class="white-icon">{{ icon }}</mat-icon>
    <div fxLayoutAlign="center center" [innerHTML]="name" style="color: white"></div>
    <div mat-dialog-actions>
        <button *ngIf="!confirmButtons" mat-button class="text-center title" (click)="confirm()">Ok</button>
        <ng-container *ngIf="confirmButtons">
            <button mat-button class="text-center title" (click)="confirm()">Sí</button>
            <button mat-button class="text-center title" (click)="reject()">No</button>
            <button mat-button class="text-center title" (click)="close()">Cancelar</button>
        </ng-container>
    </div>
</div>
